<template>
    <div class="edit">
        <div v-if="uploading" class="loader__box">
          <div class="loader__box__loader"></div>
          <h1 v-if="selected.new">Uw nieuwsartikel wordt toegevoegd</h1>
          <h1 v-else>Uw nieuwsartikel wordt aangepast</h1>
          <p>Een ogenblik geduld aub</p>
        </div>
        <div class="edit__box" v-else>
          <div class="edit__box__titel">
              <h1 v-if="selected.titel != ''">{{ selected.titel }}</h1>
              <h1 v-else>Nieuw Artikel</h1>
              <p>Hier kan u de inhoud van het nieuwsbericht aanpassen.</p>
          </div>
          <div class="edit__box__project">
            <div class="edit__box__project__wrapper">
                <form action="">
                  <div class="form_control">
                      <label>Titel</label>
                      <input type="text" v-model="selected.titel" placeholder="Artikel Titel">
                  </div>
                  <div class="form_control">
                      <label>Intro</label>
                      <textarea cols="10" rows="15" v-model="selected.intro" placeholder="Intro van het artikel"></textarea>
                  </div>
                  <div class="form_control">
                      <label>Tips & Tricks / Weetjes</label>
                      <textarea cols="10" rows="15" v-model="selected.tips" placeholder="Tips & Tricks / Weetjes"></textarea>
                  </div>
                  <div class="file_input">
                    <div class="form_control">
                        <label for="foto">Hoofdafbeelding</label>
                        <input type="file" id="foto" name="foto" @change="addImage">
                    </div>
                  </div>
                </form>
                <div class="edit__box__input__hoofdafbeelding__img">
                    <img v-if="selected.img == ''" src="assets/img_placeholder.png" alt="">
                    <img v-else :src="selected.img" alt="">
                </div>
            </div>
            <PagesNieuwsEditArtikel
                v-for="sectie in sections"
                :key="sectie"
                :s_id="sectie.id"
                :temp_id="sectie.temp_id"
                :titel="sectie.titel"
                :artikel="sectie.artikel"
                :image="sectie.img"
                :position="sectie.position"
                @section_delete="deleteSection"
                @section_delete_temp="deleteTempSection"
                @artikel-update="updateSections"
            />
            <div class="edit__box__nieuwsbuttons">
                <div class="edit__box__nieuwsbuttons__button" @click="addSection('left')">
                    <i class="fa-solid fa-image"></i>
                    <i class="fa-solid fa-align-justify"></i>
                    <p>Foto links en tekst rechts</p>
                </div>
                <div class="edit__box__nieuwsbuttons__button" @click="addSection('right')">
                    <i class="fa-solid fa-align-justify"></i>
                    <i class="fa-solid fa-image"></i>
                    <p>Text links en foto rechts</p>
                </div>
            </div>
            <div class="edit__box__input__buttons">
                <p>{{ selected.edit }}</p>
                <div class="edit__box__input__buttons__button">
                    <p class="button_2" @click="$emit('click_back')">Terug</p>
                    <p class="button" @click="saveEdit">Opslaan</p>
                </div>
            </div>
              
          </div>
        </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios'
  import PagesNieuwsEditArtikel from './NieuwsEditArtikel.vue'
  export default {
      props:["p_id"],
      inject:["data", "status"],
      data(){
          return{
              p: this.$props.p_id,
              selected: {
                  new: false,
                  id: "",
                  titel: "",
                  locatie: "",
                  beschrijving: "",
                  img: "",
                  edit: ""
              },
              sections:[],
              deleteSections: [],
              uploadImg: "",
              newId: 0,
              uploading: false
          }
      },
      created(){
          if(this.p === ""){
              this.selected = {
                  new: true,
                  id: "",
                  titel: "",
                  tips: "",
                  locatie: "",
                  beschrijving: "",
                  img: ""
              }
          } else{
             this.getData();
          }
      },
      methods:{
        addImage(event){
            this.uploadImg = event.target.files;
            this.selected.img = URL.createObjectURL(event.target.files[0])
        },
        async getData(){
            let data;
            await axios.get(this.status.api + '/get/nieuws.php',{ 
                params:{ 
                    userKey: this.status.userKey,
                    userMail: this.status.userMail,
                    userPass: this.status.userPass,
                    db: this.status.db,
                    id: this.$props.p_id
                }
                }).then(function(response){
                        data = response.data;          
                }).catch(function(error){ 
                    console.log(error);
            });
            this.selected = data[0];
            await axios.get(this.status.api + '/get/nieuws-sections.php',{ 
                params:{ 
                    userKey: this.status.userKey,
                    userMail: this.status.userMail,
                    userPass: this.status.userPass,
                    db: this.status.db,
                    id: this.p
                }
                }).then(function(response){
                        data = response.data;          
                }).catch(function(error){ 
                    console.log(error);
            });
            this.sections = data;
        },  
        addSection(x){
            this.newId++
            let newSection = {
                id: "new",
                temp_id: this.newId,
                titel: "",
                artikel: "",
                img: "",
                position: x,
                upload: false
            }
            this.sections.push(newSection);
        },
        deleteSection(x){
            for(let i = 0; i < this.sections.length; i++){
                if(this.sections[i].id == x){
                    this.sections.splice(i, 1);
                    this.deleteSections.push(x)
                }
            }
        },
        deleteTempSection(x){
            console.log(x);
            for(let i = 0; i < this.sections.length; i++){
                if(this.sections[i].temp_id == x){
                    this.sections.splice(i, 1);
                }
            }
        },
        updateSections(x){
            if(x.id == "new"){
                for(let i = 0; i < this.sections.length; i++){
                    if(this.sections[i].temp_id == x.temp_id){
                        this.sections[i].titel = x.titel;
                        this.sections[i].artikel = x.artikel;
                        this.sections[i].img = x.img;
                        this.sections[i].foto = x.foto;
                        this.sections[i].upload = x.upload;
                        this.sections[i].position = x.position;
                    }
                }
            } else{
                for(let i = 0; i < this.sections.length; i++){
                    if(this.sections[i].id == x.id){
                        this.sections[i].titel = x.titel;
                        this.sections[i].artikel = x.artikel;
                        this.sections[i].img = x.img;
                        this.sections[i].foto = x.foto;
                        this.sections[i].upload = x.upload;
                        this.sections[i].position = x.position;
                    }
                }
            }
        },  
        async saveEdit(){
            this.uploading = true;
            let data;
            if(this.selected.new){
                let date = new Date();
                const months = ["Januari", "Februari", "Maart", "April", "Mei", "Juni", "Juli", "Augustus", "September", "Oktober", "November", "December"];
                let editText = "Aangemaakt op " + date.getDate() + " " + months[date.getMonth()] + " " + date.getFullYear() + " om " + date.getHours() + ":" + date.getMinutes() + " door " + this.status.userName;
                let hoofdafbeelding = "";
                if(this.uploadImg.length == 1){
                    hoofdafbeelding = this.uploadImg[0];
                } else {
                    hoofdafbeelding = "";
                }
                const fileList = new DataTransfer();
                let fileNumber = 0;
                for(let i = 0; i < this.sections.length; i++){
                    if(this.sections[i].upload == true){
                        fileList.items.add(this.sections[i].foto[0]);
                        this.sections[i].uploadI = fileNumber;
                        fileNumber++
                    }
                }
                await axios.post(this.status.api + '/post/new-nieuws.php', {
                    server: this.status.api,
                    userKey: this.status.userKey,
                    userMail: this.status.userMail,
                    userPass: this.status.userPass,
                    db: this.status.db,
                    id: this.selected.id,
                    titel: this.selected.titel,
                    intro: this.selected.intro,
                    tips: this.selected.tips,
                    foto: hoofdafbeelding,
                    sections: this.sections,
                    sectionFoto: fileList.files,
                    deleteSections: this.deleteSections,
                    edit: editText,
                }, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(function (response) {
                    if(response.status == 200){
                        data = true
                    }
                })
                .catch(function (error) {
                    console.error(error);
                });
 
                if(data){
                    this.$emit('click_save', 'new');
                }
            } else {
                let date = new Date();
                const months = ["Januari", "Februari", "Maart", "April", "Mei", "Juni", "Juli", "Augustus", "September", "Oktober", "November", "December"];
                let editText = "Laatst gewijzigd op " + date.getDate() + " " + months[date.getMonth()] + " " + date.getFullYear() + " om " + date.getHours() + ":" + date.getMinutes() + " door " + this.status.userName;
                let hoofdafbeelding = "";
                if(this.uploadImg.length == 1){
                    hoofdafbeelding = this.uploadImg[0];
                } else {
                    hoofdafbeelding = "";
                }
                const fileList = new DataTransfer();
                let fileNumber = 0;
                for(let i = 0; i < this.sections.length; i++){
                    if(this.sections[i].upload == true){
                        fileList.items.add(this.sections[i].foto[0]);
                        this.sections[i].uploadI = fileNumber;
                        fileNumber++
                    }
                }
                await axios.post(this.status.api + '/post/edit-nieuws.php', {
                    server: this.status.api,
                    userKey: this.status.userKey,
                    userMail: this.status.userMail,
                    userPass: this.status.userPass,
                    db: this.status.db,
                    id: this.selected.id,
                    titel: this.selected.titel,
                    intro: this.selected.intro,
                    tips: this.selected.tips,
                    foto: hoofdafbeelding,
                    sections: this.sections,
                    sectionFoto: fileList.files,
                    deleteSections: this.deleteSections,
                    edit: editText,
                }, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(function (response) {
                    if(response.status == 200){
                        data = true
                    }
                    })
                    .catch(function (error) {
                        console.error(error);
                    });
                    if(data){
                        this.$emit('click_save', 'edit');
                    }
            }
        }
      },
      components:{
        PagesNieuwsEditArtikel
      },
  }
  </script>